import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {SettingsSmsService} from '../../services/settings-sms.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'settings-sms.component.html'
})
export class SettingsSmsComponent implements OnInit, OnDestroy {

    constructor(public settingsSmsService: SettingsSmsService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.urlService.onUrlChange
            .pipe(
                tap(() => {
                    this.settingsSmsService.showDetailedView = false;
                    this.settingsSmsService.selectedItemData = null;
                }),
                flatMap(() => this.settingsSmsService.getCorporationsByQueryParams(true).pipe(takeUntil(this.urlService.instantOnUrlChange)))
            )
            .subscribe();
        this.urlService.setQueryParams('allSettingsParcels');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.settingsSmsService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.settingsSmsService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/settings-sms/settings-sms.component.ts